module.exports = __webpack_public_path__ + "static/presenting-8-a3637926a1cd4352eb219f42575f634b.jpg";